import i18n from '@/lang/i18n.js'

const desiredOrder = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 21, 20, 15, 14, 16, 17, 18, 19]

export const uploadExcelFailMessage = (excelUploadErrors) => {
  let errorText = ''
  let showDownloadBtn = false
  const setErrorCol = (columns, needDownload = false) => {
    let colNames = ''
    if (columns && columns.length > 0) {
      for (let i = 0; i < columns.length; i++) {
        if (i > 9) break
        colNames = `${colNames}${columns[i]}`
        if (i + 1 < columns.length && i < 9) colNames = `${colNames}、`
      }
      if (columns.length > 10) colNames = `${colNames}，${i18n.t('Fee.ErrorExcess')}`
    }
    if (needDownload) colNames = `${colNames}，${i18n.t('Fee.PleaseDownloadTemplate')}`
    colNames = `${colNames}。`
    return colNames
  }
  const sortedUploadErrors = sortUploadExcelFailMessage(excelUploadErrors)
  sortedUploadErrors.forEach((item, index) => {
    switch (item.ErrorType) {
      case 1:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage1')}`
        break
      case 2:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage2')}`
        break
      case 3:
        showDownloadBtn = true
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage3')}`
        errorText = `${errorText}${setErrorCol(item.Columns, true)}`
        break
      case 4:
        showDownloadBtn = true
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage4')}`
        errorText = `${errorText}${setErrorCol(item.Columns, true)}`
        break
      case 5:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage5')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 6:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage6')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 7:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage7')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 8:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage8')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 9:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage9')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 10:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage10')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 11:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage11')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 12:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage12')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 13:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage13')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 14:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage14')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 15:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage15')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 16:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage16')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 17:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage17')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 18:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage18')}`
        break
      case 19:
        showDownloadBtn = true
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage19')}`
        break
      case 20:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage20')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 21:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage21')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
      case 22:
        errorText = `${errorText}${i18n.t('Fee.UploadExcelErrorMessage22')}`
        errorText = `${errorText}${setErrorCol(item.Columns)}`
        break
    }
    if (index + 1 < sortedUploadErrors.length) errorText = `${errorText}<br>`
  })
  errorText = `<p style="color: #c44536">${errorText}</p>`

  return { errorText, showDownloadBtn }
}

const sortUploadExcelFailMessage = (excelUploadErrors) => {
  const sortedExcelUploadErrors = excelUploadErrors.sort((a, b) => {
    const indexA = desiredOrder.indexOf(a.ErrorType)
    const indexB = desiredOrder.indexOf(b.ErrorType)

    if (indexA === -1 && indexB === -1) return a.ErrorType - b.ErrorType
    if (indexA === -1) return 1
    if (indexB === -1) return -1
    return indexA - indexB
  })
  return sortedExcelUploadErrors
}

export const checkPaymentDate = (start, end) => {
  const startDate = new Date(start)
  const endDate = new Date(end)
  const today = new Date()
  const oneYearLater = today.setDate(today.getDate() + 365)
  const oneYearLaterDate = new Date(oneYearLater)

  if (
    endDate.getTime() > oneYearLaterDate.getTime() ||
    startDate.getTime() > oneYearLaterDate.getTime()
  ) return new Error(i18n.t('Fee.RangeDateMustBeWithinOneYear'))
}

export const checkBarcodeDate = (barcode, end) => {
  const barcodeDate = new Date(barcode)
  const endDate = new Date(end)
  const today = new Date()
  const oneYearLater = today.setDate(today.getDate() + 365)
  const oneYearLaterDate = new Date(oneYearLater)

  if (barcodeDate.getTime() < endDate.getTime()) return new Error(i18n.t('Fee.BarcodeDateGreaterThanEndDate'))
  if (barcodeDate.getTime() > oneYearLaterDate.getTime()) return new Error(i18n.t('Fee.BarcodeDateMustBeWithinOneYear'))
}

export const BILL_AMOUNT_MAX = 200000
export const BILL_AMOUNT_MIN = -99999
